module.exports = __webpack_public_path__ + "img/3.ec03f897.png";